import { SearchForm } from "./SearchForm";
import { searchSuggest } from "./searchSuggest";

const SEARCH_FORM_CLASS = "js_squirrel_searchForm";
const SEARCH_CONTAINER_CLASS = "js_squirrel_searchContainer";
const SEARCH_RESULT_ID = "san_searchResult";
const SEARCH_RESULT_QUERY_REDUCTION_QUERY_ID = "san_qr-query";
const SEARCH_RESULT_DATA_USERQUERY_ATTRIBUTE = "data-userquery";
const SEARCH_FIELD_DATA_SEARCH_TERM = "data-suggest-search-term";
const SEARCH_RESULT_ERROR_NO_RESULTS_CLASS = "san_error__no-results";
const isAlreadyInitialized = false;
let searchForm: SearchForm;

export function focusHeaderSearchField() {
  if (Boolean(searchForm).valueOf()) {
    searchForm.focusSearchField();
  }
}

export function init() {
  let meta: Element | null;
  let headerForm: HTMLCollectionOf<HTMLFormElement>;
  const searchContainer: HTMLDivElement = document.getElementsByClassName(SEARCH_CONTAINER_CLASS)[0] as HTMLDivElement;

  if (!isAlreadyInitialized && !!searchContainer) {
    headerForm = searchContainer.getElementsByClassName(SEARCH_FORM_CLASS) as HTMLCollectionOf<HTMLFormElement>;
    if (headerForm.length > 0) {
      searchForm = new SearchForm(headerForm[0], () => {
        window.o_global.eventLoader.onReady(2, () => {
          const searchResult: HTMLDivElement = document.getElementById(SEARCH_RESULT_ID) as HTMLDivElement;
          // TODO: is this still needed?
          const searchResultQr: HTMLElement = document.getElementById(
            SEARCH_RESULT_QUERY_REDUCTION_QUERY_ID
          ) as HTMLElement;
          let query = "";

          if (Boolean(searchResult).valueOf()) {
            query = searchResult.getAttribute(SEARCH_RESULT_DATA_USERQUERY_ATTRIBUTE) || "";
          } else if (Boolean(searchResultQr).valueOf()) {
            query = searchResultQr.getAttribute(SEARCH_RESULT_DATA_USERQUERY_ATTRIBUTE) || "";
          }

          if (query !== "") {
            if (searchForm.isEmpty()) {
              searchForm.setValue(query);
              searchForm.setSearchFieldAttribute(SEARCH_FIELD_DATA_SEARCH_TERM, query);
              searchForm.toggleButtonVisibility();
            }
          }

          if (Boolean(searchSuggest).valueOf()) {
            window.o_squirrel.searchSuggest.init();
          }
        });
      });

      const searchField: HTMLInputElement = searchForm.getSearchField();

      if (searchField) {
        const _setMetaAttributes = (evt: Event) => {
          meta = document.querySelector('meta[name="viewport"]');
          meta &&
            meta.setAttribute(
              "content",
              "width=device-width, initial-scale=1" + (evt.type === "blur" ? "" : ",maximum-scale=1")
            );
        };

        searchField.addEventListener("focus", _setMetaAttributes);
        searchField.addEventListener("blur", _setMetaAttributes);
      }
    }
  }

  // Activate the second form on error pages
  window.o_global.eventLoader.onReady(2, () => {
    const errorSearch: HTMLCollectionOf<Element> = document.getElementsByClassName(
      SEARCH_RESULT_ERROR_NO_RESULTS_CLASS
    );
    if (errorSearch.length > 0) {
      const searchForm: HTMLFormElement = errorSearch[0].getElementsByClassName(
        SEARCH_FORM_CLASS
      )[0] as HTMLFormElement;
      new SearchForm(searchForm);
    }
  });
}

export interface SearchHandler {
  init: () => void;
  focusHeaderSearchField: () => void;
}

export const searchHandler = { init, focusHeaderSearchField };
